/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_No_Power_DataInputs */

const en_ui_color_by_reason_no_power_data = /** @type {(inputs: Ui_Color_By_Reason_No_Power_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No power data`)
};

const de_ui_color_by_reason_no_power_data = /** @type {(inputs: Ui_Color_By_Reason_No_Power_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Leistungsdaten`)
};

/**
* | output |
* | --- |
* | "No power data" |
*
* @param {Ui_Color_By_Reason_No_Power_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_no_power_data = /** @type {((inputs?: Ui_Color_By_Reason_No_Power_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_No_Power_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_no_power_data(inputs)
	return de_ui_color_by_reason_no_power_data(inputs)
});